import { Breadcrumb, Modal, Steps } from 'antd';
import React, { FunctionComponent, useEffect, useState } from 'react';
import { getDealHeaderInfo, sendDealReportByEmail } from '../../../api/NetworkingDeals';
import { getResource } from '../../../helpers/ResourcesHelper';
import Button from '../../inputs/Button';
import { Deal } from '../../models/Deal';
import PaymentDisburse from '../disburse/PaymentDisburse';
import Summary from '../summary/Summary';
import Spot from './Spot';

const { Step } = Steps;

interface SpotContainerProps {
  fromOtherScreenDealObj: Deal;
  fromOtherScreenSpot: string;
  objOrderScreen?: {} | null;
  fromBalances: boolean | false;
  returnToBalances?: Function;
}

const SpotContainer: FunctionComponent<SpotContainerProps> = (props) => {
  const [currentScreen, setCurrentScreen] = useState(0);
  const [dealID, setDealID] = useState(0);
  const [sellCurrency, setSellCurrency] = useState('');
  const [buyCurrency, setBuyCurrency] = useState('');
  const [valueDate, setValueDate] = useState('');
  const [settlementInstrument, setSettlementInstrument] = useState('');
  const [deliveryMethod, setDeliveryMethod] = useState('');
  const [customerRate, setCustomerRate] = useState(0.0);
  const [amountToDisburse, setAmountToDisburse] = useState(0.0);

  const [fromOtherScreenDealObj, setFromOtherScreenDealObj] = useState<Deal>(new Deal(0, '', '', '', 0, 0, '', '', ''));
  const [fromOtherScreen, setfromOtherScreen] = useState<string>('');
  const [showInputDisbursements, setShowInputDisbursements] = useState(false);

  useEffect(() => {
    if(props.fromOtherScreenSpot === 'balances')
    {
      setfromOtherScreen(props.fromOtherScreenSpot);
      setFromOtherScreenDealObj(props.fromOtherScreenDealObj);
    }
  }, [props.fromOtherScreenSpot])

  const onAcceptSpot = (dealHeaderID: number, sellCurrencyID: string, buyCurrencyID: string, amount: number, valueDate: string, instrument: string, delMethod: string, customRate: number, changePage: boolean, dealStatus: string) => {
    setDealID(dealHeaderID);
    setSellCurrency(sellCurrencyID);
    setBuyCurrency(buyCurrencyID);
    setAmountToDisburse(amount);
    setDeliveryMethod(delMethod);
    setCustomerRate(customRate);
    setValueDate(valueDate);
    setSettlementInstrument(instrument);
    if (props.fromBalances) {
      setCurrentScreen(2);
    }
    else {
      if (dealStatus === 'Accepted') {
        setShowInputDisbursements(true);
      }
      else {
        if (changePage) { changeStep() }
      }
    }
  };
  const changeStep = () => {
    setCurrentScreen(1);
  }
  const onSubmitDisbursements = (dealHeaderID: number) => {
    setCurrentScreen(2);
    sendConfirmationMail(dealHeaderID);
  };

  const onNewTradeClick = () => {
    setCurrentScreen(0);
  };

  const backToPayments = () => {
    setCurrentScreen(0);
    setDealID(0);
  };

  const confirmInputDisbursements = () => {
    changeStep();
    setShowInputDisbursements(false);

  }

  const cancelInputDisbursements = () => {

    sendConfirmationMail(dealID);
    setShowInputDisbursements(false);

  }

  const sendConfirmationMail = (dealHeaderID: number) => {
    getDealHeaderInfo(dealHeaderID).then(
      (json) => {
        let emails = json.dealHeaderInfo[0].Email.split(';');

        let sendDealReportByEmailRequest = {
          DealHeaderID: dealHeaderID,
          Language: json.dealHeaderInfo[0].PreferredLanguage,
          SendTrader: true,
          DealMailInfo: []
        }

        let DealMailInfo = [] as any;

        let userSession = JSON.parse(localStorage.getItem('UserSession')!);
        emails.forEach((value: any) => {
          DealMailInfo.push({
            MainInfo: value,
            DocType: 'Confirmation',
            MobilePhone: userSession.MobileNumber
          });
        });

        sendDealReportByEmailRequest.DealMailInfo = DealMailInfo;
        sendDealReportByEmail(sendDealReportByEmailRequest);
        setCurrentScreen(2);
      }
    );
  }

  return (
    <React.Fragment>
      <div className="screen-container">
      <Steps current={currentScreen}>
          <Step title={getResource('Btn_GetQuote')} />
          <Step title={getResource('Disburse')} />
          <Step title={getResource('ViewPrintSummary')} />
      </Steps>
      </div>
      {currentScreen === 0 && <Spot onAcceptTrade={onAcceptSpot} dealObj={fromOtherScreenDealObj} dealHeaderID={dealID} fromOtherScreen={fromOtherScreen} objOrderScreen={props.objOrderScreen} changeStep={changeStep} fromBalances={props.fromBalances} returnToBalances={props.returnToBalances} />}
      {currentScreen === 1 && (
        <PaymentDisburse dealObject={null} sellCurrency={sellCurrency} buyCurrency={buyCurrency} amount={amountToDisburse} dealHeaderID={dealID} valueDate={valueDate} settlementInstrument={settlementInstrument} onSubmit={onSubmitDisbursements} deliveryMethod={deliveryMethod} customerRate={customerRate} onBack={backToPayments} />
      )}
      {currentScreen === 2 && <Summary dealHeaderID={dealID} useNewTradeButton={true} onClickNewTrade={onNewTradeClick} useConfirmationButton={true} />}

      <Modal
        title={
          <div className="breadcrumb-container">
            <Breadcrumb separator="">
              <Breadcrumb.Item >{getResource('Js_MessageError_TitleSuccess')}</Breadcrumb.Item>
            </Breadcrumb>
          </div>
        }
        open={showInputDisbursements}
        centered
        footer={null}
        onCancel={cancelInputDisbursements}
        maskClosable={false}

        zIndex={1021}
        closable={false}
      >
        <div>
          <div>
            <h4>{getResource('Deal_Accepted')}</h4>
            <h4>{getResource('Confirm_Input_Disbursements')}</h4>
            <br />
            <h5>{getResource('Note_Input_Disbursements')}</h5>
          </div>
          <div className="row-actions-w">
            <Button id="confirmation-afex-OK" type="primary" onClick={confirmInputDisbursements}>
              {getResource('Yes')}
            </Button>
            <Button id="confirmation-afex-cancel" type="primary" onClick={cancelInputDisbursements}>
              {getResource('No')}
            </Button>
          </div>
        </div>
      </Modal>
    </React.Fragment>
  );
};

export default SpotContainer;
